import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect width="48" height="48" rx="24" fill="white" />
    <mask
      id="mask0_24642_5597"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="14"
      y="14"
      width="20"
      height="20"
    >
      <rect x="14" y="14" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_24642_5597)">
      <path d="M20.6665 29.8337V18.167L29.8332 24.0003L20.6665 29.8337Z" fill="#1C1B1F" />
    </g>
  </svg>
);

export default Icon;
